module.exports = __webpack_public_path__ + "static/media/culturas_fundo_1.bad0f5da.jpg";